/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Core
import PropTypes from "prop-types";
import { useState } from "react";

// Components
import Box from "@mui/material/Box";
import InputV1 from "components/Atoms/Input/InputV1";

function CustomCell({ value, unit, disabled, onChange, placeholder, reference, name }) {
  const [isValid, setIsValid] = useState(null);

  return (
    <Box sx={{ maxWidth: 200 }}>
      <InputV1
        value={value}
        type="number"
        name={name}
        disabled={disabled}
        size="small"
        withUnit={unit && { unit, direction: "right" }}
        onChange={(e) => {
          onChange(e, reference);
          setIsValid(parseFloat(e.target.value) >= 0);
        }}
        onWheel={(e) => e.target.blur()}
        placeholder={placeholder}
        error={isValid === false}
      />
    </Box>
  );
}

CustomCell.defaultProps = {
  value: new Intl.NumberFormat("en-US", { minimumFractionDigits: 1 }).format(0),
  unit: null,
  disabled: false,
  onChange: null,
  placeholder: "0.0",
  reference: null,
  name: "",
};

CustomCell.propTypes = {
  value: PropTypes.number,
  unit: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  reference: PropTypes.string,
  name: PropTypes.string,
};

export default CustomCell;
